import AppLogoIcon from "./app-logo-icon";

export default function AppLogo() {
  return (
    <>
      <div className="text-sidebar-primary-foreground flex aspect-square size-8 shrink-0 items-center justify-center rounded-md">
        <AppLogoIcon className="size-6 fill-current text-white" />
      </div>
      <div className="ml-1 grid flex-1 text-left text-md group-data-[collapsible=icon]:hidden">
        <span className="mb-0.5 truncate leading-tight font-bold text-lg">
          Compralytics
        </span>
      </div>
    </>
  );
}
